module.exports = __webpack_public_path__ + "media/images/icon__checkmark@2x-4fe9f906539d5d04d1810b1f26568da1.png";